module.exports = __webpack_public_path__ + "media/images/desktop/more-2-001caa45f9a0df2a0aed2eef45827a23.svg";